import { LoadScript, useLoadScript } from "@react-google-maps/api";
import React, { useEffect, useRef } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
function isGoogleMapsLoaded() {
  return window.google !== undefined;
}

const PlaceInput = ({
  key,
  value,
  onChanges,
  point,
  setPoint,
  error,
  setError,
  name,
  id,
  disabled = false,
}) => {
  const isLoaded = isGoogleMapsLoaded();

  useEffect(() => {
    if (!isLoaded) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&libraries=places`;
      document.body.appendChild(script);
    }
  }, [isLoaded]);
  return (
    <GooglePlacesAutocomplete
      key={process.env.GOOGLE_MAP_API_KEY}
      value={value}
      selectProps={{
        point,
        onChange: onChanges,
        isDisabled: disabled,
      }}
      onChange={(e) => {
        setError("");
      }}
      className={error ? "form-control input-error" : "form-control "}
      name={name}
      id={id}
      // apiKey={"AIzaSyCPUDU0R4IutXMlinajGnm1tNQvUpoSNVs"}
      // disabled={!isLoaded}
    />
  );
};

export default PlaceInput;
